import { useRef, useState, useEffect } from 'react';

const useOverflowList = <T,>(list: T) => {

    const containerRef = useRef<HTMLDivElement>(null);
    const childrenContainerRef = useRef<HTMLDivElement>(null);
    const [overflowCount, setOverflowCount] = useState(0);


    useEffect(() => {

        const calculateOverflow = () => {

            const container = containerRef.current;
            const childrenContainer = childrenContainerRef.current;
            if (container && childrenContainer) {
                const containerWidth = container.clientWidth;
                const containerOffsetLeft = container.offsetLeft;
                const items = childrenContainer.children;
                let hiddenCount = 0;

                for (const item of items) {
                    const newItem = item as HTMLElement;
                    if (newItem.offsetLeft - containerOffsetLeft + newItem.offsetWidth > containerWidth)
                        hiddenCount++;
                }

                setOverflowCount(hiddenCount);
            }
        };

        calculateOverflow();

        window.addEventListener('resize', calculateOverflow);

        return () => window.removeEventListener('resize', calculateOverflow);

    }, [list]);

    return { overflowCount, childrenContainerRef, containerRef };

};

export default useOverflowList;
